<template>
  <CHeader with-subheader class="fixed-top shadow-sm" style="height: 60px; z-index: 1031;">
    <CToggler in-header class="ml-3 d-lg-none" @click="$store.commit('toggleSidebarMobile')"/>
    <CToggler in-header class="ml-3 d-md-down-none" @click="$store.commit('toggleSidebarDesktop')"/>

    <CHeaderBrand class="pl-2 ml-2 ml-md-4 mr-auto" to="/supervisor">
      <div class="d-flex align-items-center">
        <img class="logo-custom py-1" src="@/assets/logo.svg">
        <div class="text-black ml-2">
          <p class="font-weight-bold mb-0 brand-title">MFU</p>
          <p class="font-weight-bold mb-0 brand-subtitle d-none d-sm-block">{{ $t('brand.maintenanceShort') }}</p>
        </div>
      </div>
    </CHeaderBrand>

    <CHeaderNav class="d-flex align-items-center ml-auto pr-2">
      <LanguageSwitcher class="mr-1 mr-md-2" />
      <div class="my-text-style pr-2 d-none d-md-block">
        {{ profile ? profile.name : '' }} {{ profile ? profile.surname : '' }}
      </div>
      <div class="my-text-style profile-name-mobile pr-2 d-md-none">
        {{ profile ? (profile.name.length > 8 ? profile.name.substring(0,8)+'..' : profile.name) : '' }}
      </div>
      <TheHeaderDropdownAccnt class="pr-1 pr-md-3"/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'
import { mapGetters } from "vuex";

export default {
  name: 'TheHeader',
  components: { TheHeaderDropdownAccnt, LanguageSwitcher },
  computed: { ...mapGetters("auth", ["profile", "role"]) },
}
</script>

<style scoped>
/* Desktop */
.logo-custom { height: 50px; width: auto; }

.brand-title { font-size: 1.25rem; }
.brand-subtitle { font-size: 1rem; }
.my-text-style { 
  font-family: 'Arial', sans-serif; font-size: 15px; color: #333333; font-weight: bold; 
  white-space: nowrap; text-align: right; 
}

/* Mobile */
@media (max-width: 768px) {
  .logo-custom { height: 35px; }
  .brand-title { font-size: 1rem; line-height: 1.2; }
  .profile-name-mobile {
    font-size: 11px;
    font-weight: bold;
    color: #333333;
    max-width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

@media (max-width: 480px) {
  .brand-title { font-size: 0.9rem; }
}
</style>